// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Component Imports
import Icon from '../../../../components/icon'

// **Style Imports
import './index.scss'

const PracticeModeLoading = () => {
  return (
    <Box className="practice-loading-container">
      <Icon icon="svg-spinners:blocks-shuffle-3" className="loading-icon" />
      <Box className="loading-text-wrapper">
        <Typography variant="h4" className="loading-title">
          Preparing Your Prep Environment
        </Typography>
        <Typography className="loading-description">
          Initializing standard practice modules and challenges...
        </Typography>
      </Box>
    </Box>
  )
}

export default memo(PracticeModeLoading)
